export default __webpack_public_path__ + "static/media/josh-everett-cv.4ca1d1c6.pdf";